import {useState, useEffect, useRef} from 'react';

export const useStateWithCallbackLazy = (initialValue) => {
  const callbackRef = useRef(null);
  const [value, setValue] = useState(initialValue);
  useEffect(() => {
    if (callbackRef.current) {
      callbackRef.current(value);
      callbackRef.current = null;
    }
  }, [value]);
  const setValueWithCallback = (newValue, callback) => {
    callbackRef.current = callback;
    return setValue(newValue);
  };
  return [value, setValueWithCallback];
};

// Hook
export function usePrevious(value) {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  const ref = useRef();

  // Store current value in ref
  useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes

  // Return previous value (happens before update in useEffect above)
  return ref.current;
}


export const useDebouce = (value, delay = 1000) => {
  const [state, setState] = useState(value);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setState(value)
    },delay)

    return () => {
      clearTimeout(timeout)
    }
  },[value])

  return state;
}